import React from "react";
import LazyLoader from "./LazyLoader";
import '../../src/assets/css/style.css';
import CustomLine from "./CustomLine";

const PersonalizedNutrition = () => {
    return (
        <div className="custom-padding pt-80 pb-80 xl-screen-padding relative">
            <div className="video-background">
                <video autoPlay loop muted className="background-video">
                    <source src={require("../../src/assets/videos/DNA_video.mp4")} type="video/mp4" />
                    video
                </video>
            </div>

            <img
                src={require("../../src/assets/images/spoon_image2.png")}
                alt="Small Image"
                className="spoon-image1 animate-up-down"
            />

            <div className="relative z-10">
                <div className="w-full text-center mb-8 relative z-10">
                    <h2 className="text-xl typewriter-effect md:text-2xl lg:text-3xl font-bold client-text mb-1 mt-4 text-white">
                        Why Personalized Nutrition?
                    </h2>
                    <p className="text-sm md:text-base text-white font-lato">
                        Because you are unlike anyone else.
                    </p>
                </div>

                <div className="w-full mb-6 relative z-10">
                    <div className="bg-[rgba(225,232,235,0.7)] text-white p-6 shadow-lg">
                    <hr className="border-t-2 border-[#8f762c] w-full sm:w-4/5 md:w-full lg:w-2/3 xl:w-1/2 2xl:w-1/3 hidden sm:block" />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 container-tab">
                            <div className="flex flex-col">
                                <p className="text-md">
                                    <span className="text-[#7c517e] font-bold text-h2">
                                        Each body is different
                                    </span>
                                    <span className="text-[#000000] text-p">
                                        —your metabolism, your sensitivities, your activity levels. So why would a generic nutrition plan work for you? Instead of following trends, we focus on what truly matters: your body, your health goals, your lifestyle.
                                    </span>
                                </p>
                                <p className=" text-[#000000] mt-4 text-p">
                                    Whether you're aiming to lose weight, boost your energy, manage a chronic condition, or simply feel better every day, we believe that personalized nutrition is the key to achieving lasting results.
                                </p>
                                <p className="custom-padding-bottom text-[#000000] mt-4 text-p">
                                    By understanding your individual needs, we can craft a plan that not only supports your goals but also fits seamlessly into your life.
                                </p>
                            </div>

                            <div className="flex justify-center items-center">
                                <LazyLoader
                                    src={require("../../src/assets/images/whypersonalise2.jpg")}
                                    alt="Image"
                                    placeholder="#f0f0f0"
                                    className="w-full h-auto rounded-lg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default PersonalizedNutrition;
